import { SUBSTATUS } from "./Substatus.types";

export class STATUS {
    public static INACTIVE = 0;
    public static ACTIVE = 1;
    public static PASSIVE = 2;
    public static EXPECTED = 3;

    public static getLabelByValue = (item: any) => {
        switch (parseInt(item)) {
            case STATUS.ACTIVE:
                return 'Active';
            case STATUS.PASSIVE:
                return 'Passive';
            case STATUS.INACTIVE:
            default:
                return 'Inactive';
        }
    }

    public static isActive = (item: STATUS) => item === STATUS.ACTIVE || item === 'ACTIVE';
    public static isInactive = (item: STATUS) => item === STATUS.INACTIVE || item === 'INACTIVE';
    public static isPassive = (item: STATUS) => item === STATUS.PASSIVE || item === 'PASSIVE';
    public static isExpected = (item: STATUS) => item === STATUS.EXPECTED;

    public static getExpectedTimeline = () => {
        return [
















        // {
        //     id: "cb2787b2-5cd7-4609-8d9c-7007601bdf4f",
        //     label: "Active",
        //     substatus: {label: SUBSTATUS.getLabelByValue(SUBSTATUS.ACTIVE.SIGNED), value: SUBSTATUS.ACTIVE.SIGNED},
        //     timelineType: 4,
        //     type: STATUS.EXPECTED,
        //     created_by: "Gillvon Amatdakoen"
        // },
        // {
        //     id: "cb2787b2-5cd7-4609-8d9c-7007601bdf4f",
        //     label: "Active",
        //     substatus: {label: SUBSTATUS.getLabelByValue(SUBSTATUS.ACTIVE.PROPOSED), value: SUBSTATUS.ACTIVE.PROPOSED},
        //     timelineType: 4,
        //     type: STATUS.EXPECTED,
        // },
        // {
        //     id: "cb2787b2-5cd7-4609-8d9c-7007601bdf4f",
        //     label: "Active",
        //     substatus: {label: SUBSTATUS.getLabelByValue(SUBSTATUS.ACTIVE.DEPLOYED), value: SUBSTATUS.ACTIVE.DEPLOYED},
        //     timelineType: 4,
        //     type: STATUS.EXPECTED
        // }
    ]
    }

    public static getStatusBySubStatus = (substatus: any) => {
        if (Object.keys(SUBSTATUS.ACTIVE).includes(substatus)) {
            return 'ACTIVE';
            // return STATUS.ACTIVE;
        }

        if (Object.keys(SUBSTATUS.INACTIVE).includes(substatus)) {
            return 'INACTIVE';
            // return STATUS.INACTIVE;
        }
        
        if (Object.keys(SUBSTATUS.PASSIVE).includes(substatus)) {
            return 'PASSIVE';
            // return STATUS.PASSIVE;
        }

        return 'INACTIVE';
        // return STATUS.INACTIVE;
    }

    public static getDropdownList = () => {
        return [
            { label: STATUS.getLabelByValue(STATUS.INACTIVE), value: STATUS.INACTIVE },
            { label: STATUS.getLabelByValue(STATUS.ACTIVE), value: STATUS.ACTIVE },
            { label: STATUS.getLabelByValue(STATUS.PASSIVE), value: STATUS.PASSIVE }
        ]
    }
}